import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { ErrorMessage, Flow, FlowWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateFlow(): UseMutationResult<
  AxiosResponse<Flow>,
  AxiosError<ErrorMessage>,
  FlowWrite
> {
  const queryClient = useQueryClient();

  const createFlow = (flow: FlowWrite): Promise<AxiosResponse<Flow>> => {
    return client.post('flows/', flow);
  };

  return useMutation(createFlow, {
    onSuccess: () => {
      queryClient.invalidateQueries('flows');
    },
  });
}
